import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ReservationGroupControllerAiGroupGetParams } from '@/apis/swaggers/v3/api/reservation/reservation-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ReservationGroupControllerAiGroupGetParams, unknown>

const fetchAiReservationGroup = async (params: ReservationGroupControllerAiGroupGetParams) => {
  const { data } = await apiClient.v3.reservationGroupControllerAiGroupGet(params);
  return checkApiResponse(data);
}

export const reservationGroupAiKeys = {
  all: [QUERY_KEY.reservationGroupControllerAiGroupGet] as const,
  list: (params: ReservationGroupControllerAiGroupGetParams) => [...reservationGroupAiKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(reservationGroupAiFindQueryOptions(params))` */
export const reservationGroupAiFindQueryOptions = (params: ReservationGroupControllerAiGroupGetParams) => ({
  queryKey: reservationGroupAiKeys.list(params),
  queryFn: () => fetchAiReservationGroup(params),
})

export const useReservationGroupAiFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: reservationGroupAiKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchAiReservationGroup(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
